export const PowerBtn = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="power-off"
      className="prefix__svg-inline--fa prefix__fa-power-off prefix__fa-w-16"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      {...props}
    >
      <path
        fill={props.fill}
        d="M400 54.1c63 45 104 118.6 104 201.9 0 136.8-110.8 247.7-247.5 248C120 504.3 8.2 393 8 256.4 7.9 173.1 48.9 99.3 111.8 54.2c11.7-8.3 28-4.8 35 7.7L162.6 90c5.9 10.5 3.1 23.8-6.6 31-41.5 30.8-68 79.6-68 134.9-.1 92.3 74.5 168.1 168 168.1 91.6 0 168.6-74.2 168-169.1-.3-51.8-24.7-101.8-68.1-134-9.7-7.2-12.4-20.5-6.5-30.9l15.8-28.1c7-12.4 23.2-16.1 34.8-7.8zM296 264V24c0-13.3-10.7-24-24-24h-32c-13.3 0-24 10.7-24 24v240c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24z"
      />
    </svg>
  )
}

export const Github = (props) => {
    return (
        <svg
          aria-hidden="true"
          data-prefix="fab"
          data-icon="github"
          className="prefix__svg-inline--fa prefix__fa-github prefix__fa-w-16"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 496 512"
          {...props}
        >
          <path
            fill={props.fill}
            d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
          />
        </svg>
      )
}

export const Twitter = (props) => {
    return (
      <svg
      aria-hidden="true"
      data-prefix="fab"
      data-icon="whatsapp"
      class="prefix__svg-inline--fa prefix__fa-whatsapp prefix__fa-w-14"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 650 650"
      {...props}
    >
      <path
        fill={props.fill}
        d="M546.704 91.89C486.526 31.584 406.482-1.582 321.229-1.582 145.609-1.583 2.67 141.368 2.67 317.118c0 56.139 14.705 111.05 42.567 159.297L.001 641.595l168.959-44.34c46.595 25.382 99.013 38.835 152.222 38.835h.13C496.944 636.09 640 493.14 640 317.401c0-85.182-33.166-165.179-93.344-225.463l.047-.047zM321.323 582.315c-47.599 0-94.218-12.827-134.895-36.957l-9.697-5.788-100.265 26.257 26.776-97.726-6.272-10.04C70.312 415.965 56.4 367.244 56.4 317.13c0-146.082 118.832-264.96 265.066-264.96 70.713 0 137.328 27.65 187.302 77.622 49.996 50.127 77.493 116.588 77.493 187.42-.118 146.187-118.95 265.066-264.96 265.066l.024.036zM466.541 383.85c-7.913-4.028-47.115-23.233-54.39-25.89-7.276-2.658-12.58-4.028-17.977 4.027-5.268 7.914-20.587 25.89-25.252 31.265-4.666 5.28-9.284 6.035-17.197 2.008-7.914-4.028-33.674-12.426-64.064-39.568-23.634-21.095-39.662-47.221-44.328-55.134-4.665-7.914-.52-12.308 3.532-16.193 3.661-3.544 7.925-9.284 11.941-13.95 4.028-4.665 5.28-7.925 7.925-13.31 2.658-5.28 1.359-9.946-.637-13.95-2.008-4.015-17.977-43.217-24.485-59.185-6.39-15.603-13.063-13.43-17.965-13.701-4.665-.237-9.945-.237-15.2-.237-5.257 0-13.95 1.996-21.225 9.933-7.276 7.914-27.898 27.26-27.898 66.45 0 39.201 28.512 77.009 32.516 82.407 4.027 5.267 56.162 85.784 136.029 120.238 18.98 8.161 33.803 13.063 45.355 16.854 19.098 6.024 36.425 5.15 50.126 3.13 15.32-2.256 47.115-19.229 53.788-37.831 6.662-18.615 6.662-34.536 4.666-37.831-1.89-3.544-7.158-5.504-15.201-9.58l-.06.048z"      />
    </svg>
      )
}

export const Facebook = (props) => {
    return (
      <svg
      aria-hidden="true"
      data-prefix="fab"
      data-icon="linkedin-in"
      class="prefix__svg-inline--fa prefix__fa-linkedin-in prefix__fa-w-14"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 690 690"
      {...props}
    >
      <path
        fill={props.fill}
        d="M228.582 205.715h126.462v64.832h1.83c17.611-31.595 60.675-64.832 124.892-64.832C615.303 205.715 640 288.818 640 396.926v220.219H508.116V421.93c0-46.536-.969-106.442-68.576-106.442-68.67 0-79.194 50.658-79.194 103.052v198.605H228.581v-411.43zM137.152 91.43c0 37.855-30.721 68.576-68.576 68.576-37.855 0-68.587-30.721-68.587-68.576 0-37.855 30.732-68.576 68.587-68.576 37.855 0 68.576 30.721 68.576 68.576zM-.011 205.715h137.163v411.43H-.011v-411.43z"        
        
        
        
        
        />    </svg>
    
      )
}

export const YouTube = (props) => {
    return (
        <svg
          aria-hidden="true"
          data-prefix="fab"
          data-icon="youtube"
          className="prefix__svg-inline--fa prefix__fa-youtube prefix__fa-w-18"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 576 512"
          {...props}
        >
          <path
            fill={props.fill}
            d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"
          />
        </svg>
      )
}

// export const YinYang = (props) => {
//     return (
//         <svg
//           aria-hidden="true"
//           data-prefix="fas"
//           data-icon="yin-yang"
//           className="prefix__svg-inline--fa prefix__fa-yin-yang prefix__fa-w-16"
//           xmlns="http://www.w3.org/2000/svg"
//           viewBox="0 0 496 512"
//           {...props}
//         >
//           <path
//             fill={props.fill}
//             d="M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 376c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-128c-53.02 0-96 42.98-96 96s42.98 96 96 96c-106.04 0-192-85.96-192-192S141.96 64 248 64c53.02 0 96 42.98 96 96s-42.98 96-96 96zm0-128c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
//           />
//         </svg>
//       )
// }

export const YinYang = (props) => {
  return (
<svg 
  // width="700"
  // height="700"
          aria-hidden="true"
          data-prefix="fas"
          data-icon="yin-yang"
          className="prefix__svg-inline--fa prefix__fa-yin-yang prefix__fa-w-16"
xmlns="http://www.w3.org/2000/svg" 
// data-name="Layer 1" 
viewBox="0 0 100 100" 
{...props}
// x="0px" 
// y="0px"
>
  <path d="M50,27.5A22.5,22.5,0,1,0,72.5,50,22.52,22.52,0,0,0,50,27.5Zm0,44.16A21.66,21.66,0,1,1,71.66,50,21.68,21.68,0,0,1,50,71.66Z"/><circle cx="50" cy="50" r="4.84" transform="translate(-3.31 3.55) rotate(-3.93)"/><path d="M64.15,54.18A14.74,14.74,0,0,0,53.44,35.65a3.54,3.54,0,0,0-3.3-2.93,3.48,3.48,0,0,0-1.7.37,10,10,0,0,1,1.49-2.53.1.1,0,0,0-.14-.13,8,8,0,0,0-3.24,5.23,14.74,14.74,0,0,0-10.7,18.53,3.5,3.5,0,0,0,.28,5.62,10.38,10.38,0,0,1-2.93,0c-.11,0-.15.15,0,.19a8.05,8.05,0,0,0,6.15.19,14.72,14.72,0,0,0,21.39,0,3.5,3.5,0,0,0,4.73-3,10.15,10.15,0,0,1,1.44,2.54.09.09,0,0,0,.18,0A8.05,8.05,0,0,0,64.15,54.18ZM50,63.92a13.91,13.91,0,0,1-9.93-4.17,3.49,3.49,0,0,0-3.48-6,13.92,13.92,0,0,1,9.93-17.21,3.49,3.49,0,0,0,7,0,13.92,13.92,0,0,1,9.93,17.21,3.49,3.49,0,0,0-3.48,6A13.91,13.91,0,0,1,50,63.92Z"></path></svg>
    )
}


export const Anchor = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="anchor"
      className="prefix__svg-inline--fa prefix__fa-anchor prefix__fa-w-18"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 576 512"
      {...props}
    >
      <path
        fill={props.fill}
        d="M12.971 352h32.394C67.172 454.735 181.944 512 288 512c106.229 0 220.853-57.38 242.635-160h32.394c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0l-67.029 67.029c-7.56 7.56-2.206 20.485 8.485 20.485h35.146c-20.29 54.317-84.963 86.588-144.117 94.015V256h52c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-52v-5.47c37.281-13.178 63.995-48.725 64-90.518C384.005 43.772 341.605.738 289.37.01 235.723-.739 192 42.525 192 96c0 41.798 26.716 77.35 64 90.53V192h-52c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v190.015c-58.936-7.399-123.82-39.679-144.117-94.015h35.146c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0L4.485 331.515C-3.074 339.074 2.28 352 12.971 352zM288 64c17.645 0 32 14.355 32 32s-14.355 32-32 32-32-14.355-32-32 14.355-32 32-32z"
      />
    </svg>
  )
}



export const Link = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="link"
      className="prefix__svg-inline--fa prefix__fa-link prefix__fa-w-16"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      {...props}
      
    >
      <path
        fill={props.fill}
        
        d="M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 01-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0120.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0020.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 00-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z"
      />
    </svg>
  )
}



export const Design = (props) => { 
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="palette"
      className="prefix__svg-inline--fa prefix__fa-palette prefix__fa-w-16"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 140 140"
      {...props}
    >
      <path
        fill={props.fill}
d="M64.94,8.92c2.03,3.52,3.42,12.25,4.15,23.81h12.97V20.46c-0.28-0.13-0.55-0.28-0.81-0.45c-0.49-0.31-0.94-0.67-1.33-1.06 l-0.05-0.05c-0.69-0.69-1.24-1.52-1.62-2.44c-0.38-0.91-0.59-1.91-0.59-2.96c0-1.04,0.21-2.03,0.59-2.95 c0.39-0.95,0.97-1.8,1.67-2.51c0.71-0.71,1.56-1.28,2.51-1.67c0.91-0.38,1.91-0.59,2.95-0.59c1.04,0,2.03,0.21,2.95,0.59 c0.95,0.39,1.8,0.97,2.51,1.67c0.71,0.71,1.28,1.56,1.67,2.5l0.02,0.06c0.36,0.9,0.56,1.88,0.56,2.89c0,1.04-0.21,2.03-0.59,2.95 c-0.39,0.95-0.97,1.8-1.67,2.51l-0.06,0.06c-0.35,0.34-0.74,0.66-1.15,0.93c-0.22,0.15-0.45,0.28-0.69,0.41v15.84 c0,0.95-0.39,1.81-1.01,2.43c-0.62,0.62-1.48,1.01-2.43,1.01H69.43c0.12,3.29,0.2,6.75,0.23,10.32h30.44 c0.13-0.26,0.27-0.51,0.42-0.75l0.04-0.05c0.29-0.45,0.63-0.86,0.99-1.22c0.71-0.71,1.56-1.28,2.51-1.67l0.06-0.02 c0.9-0.36,1.88-0.57,2.89-0.57c1.04,0,2.03,0.21,2.95,0.59c0.95,0.39,1.8,0.97,2.51,1.67c0.71,0.71,1.28,1.56,1.67,2.51 c0.38,0.92,0.59,1.91,0.59,2.95c0,1.04-0.21,2.03-0.59,2.95c-0.39,0.95-0.97,1.8-1.67,2.51c-0.71,0.71-1.56,1.28-2.51,1.67 l-0.06,0.02c-0.9,0.36-1.88,0.56-2.89,0.56c-1.04,0-2.04-0.21-2.95-0.59c-0.94-0.39-1.79-0.96-2.51-1.67 c-0.38-0.38-0.72-0.8-1.02-1.27c-0.16-0.24-0.3-0.49-0.43-0.75H69.67c-0.03,3.9-0.11,7.89-0.24,11.95h37.21 c0.95,0,1.81,0.39,2.43,1.01c0.62,0.62,1.01,1.48,1.01,2.43v25.53c0.33,0.14,0.64,0.3,0.94,0.48c0.54,0.32,1.03,0.71,1.47,1.15 c0.71,0.71,1.28,1.56,1.67,2.51l0.02,0.06c0.36,0.9,0.57,1.88,0.57,2.89c0,1.04-0.21,2.03-0.59,2.95c-0.39,0.95-0.97,1.8-1.67,2.51 c-0.71,0.71-1.56,1.28-2.51,1.67c-0.91,0.38-1.91,0.59-2.95,0.59c-1.04,0-2.03-0.21-2.95-0.59c-0.95-0.39-1.8-0.97-2.51-1.67 c-0.71-0.71-1.28-1.56-1.67-2.51c-0.38-0.91-0.59-1.91-0.59-2.95c0-1.04,0.21-2.04,0.59-2.95c0.39-0.95,0.97-1.8,1.67-2.51 c0.32-0.32,0.68-0.62,1.06-0.89c0.18-0.13,0.37-0.25,0.57-0.36V75.66H69.16c-0.15,3.24-0.33,6.49-0.55,9.73h11.04 c0.95,0,1.81,0.39,2.43,1.01c0.62,0.62,1.01,1.48,1.01,2.43v13.66c0.25,0.13,0.48,0.27,0.72,0.42c0.46,0.3,0.87,0.64,1.24,1.01 l0.06,0.06c0.68,0.7,1.24,1.53,1.62,2.45c0.38,0.91,0.59,1.91,0.59,2.95c0,1.04-0.21,2.04-0.59,2.95l-0.03,0.06 c-0.39,0.93-0.96,1.76-1.65,2.45l-0.05,0.05c-0.7,0.69-1.53,1.25-2.44,1.63c-0.91,0.38-1.92,0.59-2.96,0.59 c-1.04,0-2.03-0.21-2.95-0.59c-0.95-0.39-1.8-0.97-2.51-1.67l-0.06-0.06c-0.68-0.7-1.24-1.53-1.62-2.45 c-0.38-0.92-0.59-1.91-0.59-2.95s0.21-2.03,0.59-2.95c0.39-0.95,0.96-1.8,1.67-2.51l0,0c0.39-0.39,0.83-0.74,1.29-1.04 c0.25-0.16,0.51-0.31,0.78-0.44V92.28H68.1c-0.11,1.37-0.23,2.74-0.35,4.1c-0.16,1.76-0.67,5.01-0.34,6.62 c0.88,4.27-2.97,17.15-14.29,19.52c-5.58,1.16-11.35-0.55-15.7-3.95c-3.48-2.71-6.09-6.52-7.03-10.83 c-1.82-0.07-3.67-0.44-5.47-1.04c-3.98-1.34-7.81-3.95-10.8-7.41c-3.01-3.47-5.19-7.83-5.88-12.68c-0.35-2.53-0.3-5.17,0.26-7.89 c-1.95-1.77-3.63-3.76-4.96-5.93C1.22,69.08-0.05,64.9,0,60.6c0.05-4.33,1.43-8.72,4.42-12.8c1.74-2.37,4.03-4.63,6.93-6.7 c-0.03-0.79-0.03-1.58-0.01-2.36c0.23-6.32,2.56-11.88,5.96-16.03c3.52-4.3,8.23-7.11,13.07-7.8h0.02 c0.17-0.71,0.37-1.41,0.63-2.09c1.56-4.23,4.77-7.83,8.7-10.12c3.96-2.3,8.71-3.32,13.34-2.36C57.51,1.28,61.75,3.94,64.94,8.92 L64.94,8.92L64.94,8.92z M30.77,99.21c1.64-5.16,5.97-10.31,14.14-14.48c2.04-1.03,4.52-0.23,5.57,1.8 c1.03,2.04,0.23,4.52-1.8,5.57c-7.57,3.87-10.42,8.31-10.42,12.18c0,3.02,1.72,5.84,4.22,7.8c2.54,1.97,5.82,3,8.92,2.36 c3.86-0.8,7.58-4.37,9.51-12.15V20.49c-1.93-7.72-5.65-11.27-9.5-12.07c-2.54-0.53-5.24,0.07-7.54,1.42 c-2.33,1.35-4.2,3.43-5.09,5.83c-1.18,3.2-0.48,7.13,3.52,10.83c1.66,1.55,1.77,4.14,0.22,5.8c-1.55,1.66-4.14,1.77-5.8,0.22 c-3.11-2.88-5.03-5.94-5.99-8.99c-2.45,0.59-4.87,2.21-6.83,4.59c-2.29,2.79-3.86,6.57-4.02,10.91c-0.04,1.15,0.02,2.37,0.19,3.62 h-0.01c0.22,1.62-0.5,3.3-1.98,4.21c-3,1.84-5.21,3.87-6.76,5.98c-1.88,2.56-2.74,5.25-2.77,7.84c-0.03,2.63,0.78,5.25,2.23,7.6 c1.23,1.99,2.91,3.81,4.96,5.33c1.54,1.06,2.26,3.04,1.63,4.89c-0.81,2.4-0.99,4.73-0.68,6.9c0.44,3.12,1.89,5.97,3.87,8.26 c1.99,2.3,4.51,4.02,7.09,4.9C28.69,98.96,29.74,99.16,30.77,99.21L30.77,99.21L30.77,99.21z M31.71,41.1 c1.62-1.59,4.22-1.57,5.82,0.05c1.59,1.62,1.57,4.22-0.05,5.82c-3.53,3.48-5.37,7.96-5.57,12.54c-0.19,4.72,1.34,9.58,4.56,13.57 c1.43,1.77,1.14,4.36-0.63,5.79c-1.77,1.43-4.36,1.14-5.79-0.63c-4.51-5.59-6.65-12.39-6.38-19.06 C23.96,52.56,26.62,46.1,31.71,41.1L31.71,41.1L31.71,41.1z"


/>
    </svg>
  )

}

export const Develope = (props) => { 
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="laptop-code"
      className="prefix__svg-inline--fa prefix__fa-laptop-code prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 512"
      {...props}
    >
      <path
         fill={props.fill}
        d="M255.03 261.65c6.25 6.25 16.38 6.25 22.63 0l11.31-11.31c6.25-6.25 6.25-16.38 0-22.63L253.25 192l35.71-35.72c6.25-6.25 6.25-16.38 0-22.63l-11.31-11.31c-6.25-6.25-16.38-6.25-22.63 0l-58.34 58.34c-6.25 6.25-6.25 16.38 0 22.63l58.35 58.34zm96.01-11.3l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0l58.34-58.34c6.25-6.25 6.25-16.38 0-22.63l-58.34-58.34c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63L386.75 192l-35.71 35.72c-6.25 6.25-6.25 16.38 0 22.63zM624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"
      />
    </svg>
  )

}


export const Developement = (props) => { 
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="laptop-code"
      className="prefix__svg-inline--fa prefix__fa-laptop-code prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      {...props}
    ><polyline points="152 32 152 88 208 88" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="12"/><polyline points="148 128 172 152 148 176" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="12"/><polyline points="108 128 84 152 108 176" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="12"/>
      <path
         fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="12"
         d="M200,224a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8Z"         
         />
    </svg>
  )

}

export const Additional_Skills = (props) => { 
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="black" class="bi bi-patch-plus" viewBox="0 0 16 16"> <path fill-rule="evenodd" d="M8 5.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 .5-.5z"/> <path d="m10.273 2.513-.921-.944.715-.698.622.637.89-.011a2.89 2.89 0 0 1 2.924 2.924l-.01.89.636.622a2.89 2.89 0 0 1 0 4.134l-.637.622.011.89a2.89 2.89 0 0 1-2.924 2.924l-.89-.01-.622.636a2.89 2.89 0 0 1-4.134 0l-.622-.637-.89.011a2.89 2.89 0 0 1-2.924-2.924l.01-.89-.636-.622a2.89 2.89 0 0 1 0-4.134l.637-.622-.011-.89a2.89 2.89 0 0 1 2.924-2.924l.89.01.622-.636a2.89 2.89 0 0 1 4.134 0l-.715.698a1.89 1.89 0 0 0-2.704 0l-.92.944-1.32-.016a1.89 1.89 0 0 0-1.911 1.912l.016 1.318-.944.921a1.89 1.89 0 0 0 0 2.704l.944.92-.016 1.32a1.89 1.89 0 0 0 1.912 1.911l1.318-.016.921.944a1.89 1.89 0 0 0 2.704 0l.92-.944 1.32.016a1.89 1.89 0 0 0 1.911-1.912l-.016-1.318.944-.921a1.89 1.89 0 0 0 0-2.704l-.944-.92.016-1.32a1.89 1.89 0 0 0-1.912-1.911l-1.318.016z"/> </svg>
  )

}